import state from './moduleEhsState.js'
import mutations from './moduleEhsMutations.js'
import actions from './moduleEhsActions.js'
import getters from './moduleEhsGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
